function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FAFAFA"
});

var SvgMessageInput = function SvgMessageInput(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    d: "M20.6934 20.6639L12.2684 21.4794L10.051 28.57C9.98625 28.7751 9.98308 28.9947 10.0419 29.2015C10.1007 29.4084 10.2189 29.5935 10.3819 29.7338C10.5449 29.8741 10.7455 29.9636 10.9588 29.991C11.1721 30.0185 11.3887 29.9827 11.5819 29.8882L30.0466 20.9476C30.2236 20.8613 30.3727 20.727 30.4771 20.56C30.5814 20.393 30.6367 20.2001 30.6367 20.0032C30.6367 19.8063 30.5814 19.6134 30.4771 19.4465C30.3727 19.2795 30.2236 19.1452 30.0466 19.0589L11.5948 10.1118C11.4016 10.0173 11.185 9.98154 10.9717 10.009C10.7584 10.0364 10.5578 10.1259 10.3948 10.2662C10.2318 10.4065 10.1136 10.5916 10.0548 10.7985C9.99598 11.0053 9.99914 11.2249 10.0639 11.43L12.2813 18.5206L20.6902 19.3361C20.8542 19.3523 21.0063 19.4289 21.1169 19.551C21.2275 19.6731 21.2888 19.832 21.2888 19.9968C21.2888 20.1616 21.2275 20.3204 21.1169 20.4426C21.0063 20.5647 20.8542 20.6413 20.6902 20.6575L20.6934 20.6639Z",
    style: {
      fill: "var(--color-primary)"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessageInput, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message_input.a6264e7c.svg";
export { ForwardRef as ReactComponent };